var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlyFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1843 25.5526L3.84585 18.686C3.65739 18.4818 3.55273 18.2141 3.55273 17.9363V5.10526C3.55273 4.49484 4.04758 4 4.658 4H18.5686C18.8617 4 19.1429 4.11645 19.3501 4.32372L25.658 10.6316",
    stroke: "#8A96A3",
    strokeWidth: 3.31579,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0793 15.0522L33.7188 18.6918C34.1504 19.1234 34.1504 19.8232 33.7188 20.2548L20.9134 33.0602C20.4818 33.4918 19.782 33.4918 19.3503 33.0602L15.1582 28.868",
    stroke: "#8A96A3",
    strokeWidth: 3.31579,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 33.8421L33.3947 4",
    stroke: "#8A96A3",
    strokeWidth: 3.31579,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.2885,
    cy: 11.1841,
    r: 2.76316,
    fill: "#8A96A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyFree);
export default __webpack_public_path__ + "static/media/only_free.fc1f4fbd003fa1900cb0846f61324696.svg";
export { ForwardRef as ReactComponent };